<div class="password-requirements">
  <div class="text">{{ 'module.public.registration.passwordLabelTopText' | translate }}</div>
  <div class="error-list">
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('minlength')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('minlength')"></span>
      <div class="text">{{ 'module.modals.changePassword.newPasswordMustBeAtLeast8CharLongErrorText' | translate }}</div>
    </div>
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('numeric')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('numeric')"></span>
      <div class="text">
        {{ 'module.modals.changePassword.newPasswordMustContainAtLeastOneNumberErrorText' | translate }}
      </div>
    </div>
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('uppercase')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('uppercase')"></span>
      <div class="text">
        {{ 'module.modals.changePassword.newPasswordMustContainAtLeastOneUppercaseLetterErrorText' | translate }}
      </div>
    </div>
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('lowercase')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('lowercase')"></span>
      <div class="text">
        {{ 'module.modals.changePassword.newPasswordMustContainAtLeastOneLowercaseLetterErrorText' | translate }}
      </div>
    </div>
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('fnameNotInPassword')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('fnameNotInPassword')"></span>
      <div class="text">{{ 'module.public.registration.validationMustNotBeFirstNameText' | translate }}</div>
    </div>
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('lnameNotInPassword')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('lnameNotInPassword')"></span>
      <div class="text">{{ 'module.public.registration.validationMustNotBeLastNameText' | translate }}</div>
    </div>
    <div class="validation-group">
      <span class="fa fa-check" *ngIf="!control?.hasError('required') && !control?.hasError('specialcharacter')"></span>
      <span class="fa fa-times" *ngIf="control?.hasError('required') || control?.hasError('specialcharacter')"></span>
      <div class="text">{{ 'module.public.registration.validationOnlyAscii' | translate }}</div>
    </div>
  </div>
</div>
